import { useTranslate } from '@tolgee/react';
import React from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import { Palette } from 'color-thief-react';
import {updateBrandColors} from "../../../redux/slices/brandOnboarding/brandOnboarding";
import {PRIMARY_COLOR} from "../constants";

interface SelectColorProps {
  value: string;
  label: string;
  handleChange: (e: any) => void;
  selectAColor: (color: string) => void;
  imgSrc: string;
  primaryColor: boolean;
}

const SelectColor: React.FC<SelectColorProps> = ({
  value,
  handleChange,
  label,
  selectAColor,
  imgSrc,
    primaryColor = true
}) => {
  const { t } = useTranslate();

  return (
    <div className="d-flex ">
      <div className="w-100 d-flex flex-column gap-1">
        <div style={{ marginLeft: '50px' }}>
          <Form.Label className="ml-5" htmlFor="primaryColor">
            {label}
          </Form.Label>
        </div>
        <InputGroup className="mb-3 w-100 d-flex gap-2">
          <input
              type="color"
              className="me-2 me-2 w-45px h-45px rounded border-2 border-solid border-white"
              value={value}
              onChange={(e) => {value = e.target.value}}
              title={t('lomavis.branding.choose_primary_color')}
              style={{
                outline: 'none', // Removes outline on focus
                border: 'none',
                padding: 0,
                cursor: 'pointer',
                background: "white"
              }}

          />


          <Form.Control
            placeholder="e.g #ffffff"
            aria-label="Background color"
            aria-describedby="basic-addon1"
            id="bgColor"
            value={value}
            onChange={handleChange}
          />
        </InputGroup>

        <Palette
          src={imgSrc}
          crossOrigin="anonymous"
          format="hex"
          colorCount={4}
        >
          {({ data, loading }) => {
            if (loading)
              return (
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
              );

            if (!value && data?.length > 1) {
              selectAColor(data[primaryColor ? 0: 1]);
            }

            return (
              <div className="w-100 d-flex gap-2 justify-content-end ">
                {data?.map((color, index) => (
                  <div
                    onClick={() => {
                      selectAColor(color);
                    }}
                    key={color + index}
                    style={{
                      aspectRatio: 1,
                      height: '32px',
                      backgroundColor: color
                    }}
                    className="border rounded-3 cursor-pointer"
                  ></div>
                ))}
              </div>
            );
          }}
        </Palette>
      </div>
    </div>
  );
};

export default SelectColor;
